import React from "react";
import PropTypes from 'prop-types';

import AccessibleElement from './accessible-element';
import Icon from './icon';

import '../css/checkbox.less';

/**
 * Basic checkbox component
 */
function Checkbox({ className, checked, onChange, disabled, type, align, size, icon, counter, children, ariaLabel, readOnly, ...otherProps }) {
    const containerClass = `checkbox-container ${type} align-${align}${disabled ? ' disabled' : ''}${readOnly ? ' ready-only': ''}${className ? ' ' + className : ''}${counter != undefined ? ' checkbox-counter':''}`;

    return (<AccessibleElement element='label' ariaLabel={ariaLabel} className={containerClass}>
        <input type="checkbox"
            className={`checkbox`}
            checked={checked}
            disabled={disabled || readOnly}
            onChange={onChange}
            style={{ height: size, width: size }}
            tabIndex={-1}
            {...otherProps}
        />
        <span className='checkbox'></span>
        <Icon name={icon} size={size} />
        {children}
        {counter != undefined && <span className='counter'>{counter}</span>}
    </AccessibleElement>);
}

Checkbox.defaultProps = {
    onChange: () => { },
    size: 24,
    type: 'slim',
    icon: 'checkbox',
    align: 'left'
}

Checkbox.propTypes = {
    /** Set input checked state */
    checked: PropTypes.bool,
    /** Set input disabled*/
    disabled: PropTypes.bool,
    /** Set input as ready only*/
    readOnly: PropTypes.bool,
    /** additioanl custom class */
    className: PropTypes.string,
    /** Change handler for checkbox */
    onChange: PropTypes.func,
    /** Style types */
    type: PropTypes.oneOf(['slim', 'broad']),
    /** Checkbox alignment  */
    align: PropTypes.oneOf(['left','right']),
    /** Checkmark icon */
    icon: PropTypes.oneOf(['checkbox', 'x_square', 'plus_square', 'minus_square'])
}

export default React.memo(Checkbox);
